function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRotatePause(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("line", {
    style: {
      strokeLinecap: "round",
      stroke: "rgb(51, 51, 51)",
      strokeMiterlimit: 1,
      vectorEffect: "non-scaling-stroke",
      strokeWidth: "1.5px"
    },
    x1: 9.046,
    y1: 8,
    x2: 8.968,
    y2: 16
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      strokeLinecap: "round",
      stroke: "rgb(51, 51, 51)",
      strokeMiterlimit: 1,
      vectorEffect: "non-scaling-stroke",
      strokeWidth: "1.5px"
    },
    x1: 12.721,
    y1: 8,
    x2: 12.643,
    y2: 16
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotatePause);
export default __webpack_public_path__ + "static/media/rotate-pause.122db87d7c933869c76b2097ff7f5dfa.svg";
export { ForwardRef as ReactComponent };